<template>
  <section>
    <div class="search-form hiddenCB section-panel">
      <h4>Genre</h4>
      <div id='genres'>

        <input type="checkbox" id="drama" value="Drama" v-model="genres">
        <label for="drama">Drama</label>

        <input type="checkbox" id="thriller-mystery" value="thriller-mystery" v-model="genres">
        <label for="thriller-mystery">Thriller & Mystery</label>
        
        <input type="checkbox" id="crime" value="Crime" v-model="genres">
        <label for="crime">Crime</label>

        <input type="checkbox" id="comedy" value="Comedy" v-model="genres">
        <label for="comedy">Comedy</label>

        <input type="checkbox" id="romance" value="Romance" v-model="genres">
        <label for="romance">Romance</label>

        <input type="checkbox" id="action-adventure" value="Action" v-model="genres">
        <label for="action-adventure">Action & Adventure</label>

        <input type="checkbox" id="scifi-fantasy" value="sci-fi-fantasy" v-model="genres">
        <label for="scifi-fantasy">Sci-Fi & Fantasy</label>

        <input type="checkbox" id="horror" value="Horror" v-model="genres">
        <label for="horror">Horror</label>

        <input type="checkbox" id="war-western" value="war-western" v-model="genres">
        <label for="war-western">War & Western</label>
        
      </div>
      <h4>Time period</h4>
      <div id='time-period'>
        <input type="checkbox" id="pre-1960" value="pre-1960" v-model="timeperiod">
        <label for="pre-1960">Pre-1960</label>
        <input type="checkbox" id="1960-1990" value="1960-1990" v-model="timeperiod">
        <label for="1960-1990">1960-1990</label>
        <input type="checkbox" id="since-1990" value="since-1990" v-model="timeperiod">
        <label for="since-1990">Since 1990</label>
      </div>
      <p>By default, we'll only show you feature films with <span class="underline">75+ quality</span> and <span class="underline">50+ buzz</span> (2,300 films). <span class="italic">These are the best films that also have some buzz</span>.</p>
      <h4 class="slide-toggle">Quality <i class="fas fa-chevron-down"></i></h4>
      <div id='quality' class="slide-hidden">
        <input type="checkbox" id="quality-1" value="quality-1" v-model="quality">
        <label for="quality-1">&lt;50</label>
        <input type="checkbox" id="quality-2" value="quality-2" v-model="quality">
        <label for="quality-2">50-74</label>
        <input type="checkbox" id="quality-3" value="quality-3" v-model="quality">
        <label for="quality-3">75+</label>
      </div>
      <h4 class="slide-toggle">Buzz <i class="fas fa-chevron-down"></i></h4>
      <div id='buzz' class="slide-hidden">
        <input type="checkbox" id="buzz-1" value="buzz-1" v-model="buzz">
        <label for="buzz-1">&lt;50</label>
        <input type="checkbox" id="buzz-2" value="buzz-2" v-model="buzz">
        <label for="buzz-2">50-74</label>
        <input type="checkbox" id="buzz-3" value="buzz-3" v-model="buzz">
        <label for="buzz-3">75+</label>
      </div>
      <h4 class="slide-toggle">Docs, animation? <i class="fas fa-chevron-down"></i></h4>
      <div id='include' class="slide-hidden">
        <input type="checkbox" id="live-action" value="live-action" v-model="liveaction">
        <label for="live-action">Feature Films</label>
        <input type="checkbox" id="documentary" value="documentary" v-model="documentary">
        <label for="documentary">Docs</label>
        <input type="checkbox" id="animation" value="animation" v-model="animation">
        <label for="animation">Animation</label>
      </div>
      <h4 class="slide-toggle">Language <i class="fas fa-chevron-down"></i></h4>
      <div id='language' class="slide-hidden">
        <input type="checkbox" id="english" value="english" v-model="language">
        <label for="english">English</label>
        <input type="checkbox" id="foreign" value="foreign" v-model="language">
        <label for="foreign">Foreign</label>
      </div>
      <h4 class="search-heading" v-if="searchEnabled">Search</h4>
      <div class="pure-control-group search-term aa-input-container" id="aa-input-container" v-if="searchEnabled">
        <input id="search-term" class="aa-input-search" type="text" placeholder="Type an actor or director here" v-model="searchTerm" autocomplete="off">
      </div>
      <button class="pure-button search-matrix" v-on:click="searchMatrix(true)">Find your film</button>
    </div>
    <div class="results-panel section-panel hiddenCB" v-if="noResultsFound && resultsCount == 0">
      <p>Your search returned <strong>0</strong> films. Please adjust your selections and try again.</p>
    </div>
    <div class="results-panel section-panel hiddenCB" v-if="resultsCount > 0">
      <p>Your search returned <strong>{{resultsCount}}</strong> films. We've sorted them <span>by {{sortText}}</span>.</p>
      <h4 class="slide-toggle" v-if="sortEnabled">Sort by buzz, year, etc. <i class="fas fa-chevron-down"></i></h4>
      <div id='sortby' class="slide-hidden">
        <button class="pure-button sort-button" data-sort-button="Buzz" v-on:click="sortChange('Buzz')" v-bind:class="{'selected-button' : (prevSort == 'Buzz' || prevSort == 'BuzzAsc')}">
          Buzz
          <i class="far fa-long-arrow-alt-up" v-if="prevSort == 'BuzzAsc'"></i>
          <i class="far fa-long-arrow-alt-down" v-if="prevSort == 'Buzz'"></i>
        </button>
        <button class="pure-button sort-button" data-sort-button="Year" v-on:click="sortChange('Year')" v-bind:class="{'selected-button' : (prevSort == 'Year' || prevSort == 'YearAsc')}">
          Year
          <i class="far fa-long-arrow-alt-up" v-if="prevSort == 'YearAsc'"></i>
          <i class="far fa-long-arrow-alt-down" v-if="prevSort == 'Year'"></i>
        </button>
        <button class="pure-button sort-button" data-sort-button="Quality" v-on:click="sortChange('Quality')" v-bind:class="{'selected-button' : (prevSort == 'Quality' || prevSort == 'QualityAsc')}">
          Quality
          <i class="far fa-long-arrow-alt-up" v-if="prevSort == 'QualityAsc'"></i>
          <i class="far fa-long-arrow-alt-down" v-if="prevSort == '' || prevSort == 'Quality'"></i>
        </button>
      </div>
    </div>
    <div class="list-panel" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="1000">
      <div class="results-loader" v-if="resultsLoading"><i class="fas fa-circle-notch fa-spin"></i></div>
      <ul>
        <li v-for="film in searchResults" :data-id="film.objectID" class="section-panel">
          <MoviePanel :movieData="film" :isSearch="true" />
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
  /* global $, algoliasearch */
  import MoviePanel from './MoviePanel.vue'

  export default {
    name: 'searchForm',
    props: ['query', 'qTimeperiod', 'qGenres', 'qQuality', 'qBuzz', 'qSort', 'qSearchField', 'qSearchValue'],
    data () {
      return {
        searchEnabled: false,
        sortEnabled: false,
        genres: [],
        documentary: false,
        animation: false,
        liveaction: true,
        timeperiod: ['since-1990'],
        quality: ['quality-3'],
        buzz: ['buzz-2', 'buzz-3'],
        language: ['english', 'foreign'],
        searchLimit: 10,
        searchResults: [],
        resultsCount: 0,
        resultsLoading: false,
        isSearching: false,
        enableLoadMore: false,
        nextPage: 0,
        resultsType: '',
        dataIndex: 'movies',
        prevSort: 'Quality',
        sortText: 'quality',
        currentQuery: {},
        triggeredField: '',
        triggeredSearch: '',
        searchTerm: '',
        noResultsFound: false,
        client: null,
        index: null
      }
    },
    watch: {
      qTimeperiod (newValue) {
        if (newValue && newValue != '') {
          this.timeperiod = newValue.split(',')
          this.timeperiod = this.uniqueArray(this.timeperiod)
        }
        this.searchMatrix(true)
      },
      qGenres (newValue) {
        if (newValue && newValue != '') {
          this.genres = newValue.split(',')
          if (Array.isArray(this.genres)) {
            this.genres = this.uniqueArray(this.genres)            
          }
        }
        this.searchMatrix(true)
      },
      qQuality (newValue) {
        if (newValue && newValue != '') {
          this.quality = newValue.split(',')
          if (Array.isArray(this.quality)) {
            this.quality = this.uniqueArray(this.quality)            
          }
        }
        this.searchMatrix(true)
      },
      qBuzz (newValue) {
        if (newValue && newValue != '') {
          this.buzz = newValue.split(',')
          if (Array.isArray(this.buzz)) {
            this.buzz = this.uniqueArray(this.buzz)            
          }
        }
        this.searchMatrix(true)
      },
      qSearchValue (newValue) {
        if (newValue && newValue != '') {
          this.searchTerm = newValue
        }
        this.searchMatrix(true)
      },
      qSearchField (newValue) {
        if (newValue && newValue != '') {
          this.qSearchField = newValue
        }
        this.searchMatrix(true)
      },
    },
    created () {
      let vm = this

      vm.client = algoliasearch('EQ4MPZHE99', 'b883b4278df4fd23853990e7ed74551d')
      vm.index = vm.client.initIndex(vm.dataIndex)

      vm.$eventHub.$on('do-movie-search', function (triggeredSearch, triggeredField) {
        console.log('do-movie-search')
        vm.resultsType = 'custom'
        vm.resultsCount = 0
        $('html, body').animate({ scrollTop: $('.search-matrix').offset().top + $('.search-matrix').outerHeight() + 30 }, 'slow')
        vm.nextPage = 0
        vm.searchResults = []
        vm.prepMovieSearch(triggeredSearch, triggeredField)
      })
      vm.$eventHub.$on('do-movie-search-selected', function (triggeredSearch, triggeredField) {
        console.log('do-movie-search-selected')
        vm.resultsType = 'custom'
        vm.resultsCount = 0
        $('html, body').animate({ scrollTop: $('.search-matrix').offset().top + $('.search-matrix').outerHeight() + 30 }, 'slow')
        vm.nextPage = 0
        vm.searchResults = []
        vm.prepMovieSearch(triggeredSearch, triggeredField)
      })

      if (this.qTimeperiod || this.qGenres || this.qQuality || this.qBuzz || this.qSort || this.qSearchValue) {
        if (this.qTimeperiod && this.qTimeperiod != '') {
          this.timeperiod = this.qTimeperiod.split(',')
          this.timeperiod = this.uniqueArray(this.timeperiod)
        }
        if (this.qGenres && this.qGenres) {
          this.genres = this.qGenres.split(',')
          if (Array.isArray(this.genres)) {
            this.genres = this.uniqueArray(this.genres)            
          }
        }
        if (this.qQuality && this.qQuality != '') {
          this.quality = this.qQuality.split(',')
          if (Array.isArray(this.quality)) {
            this.quality = this.uniqueArray(this.quality)            
          }
        }
        if (this.qBuzz && this.qBuzz != '') {
          this.buzz = this.qBuzz.split(',')
          if (Array.isArray(this.buzz)) {
            this.buzz = this.uniqueArray(this.buzz)            
          }
        }

        if (this.qSearchValue && this.qSearchValue != '') {
          this.searchTerm = this.qSearchValue
        }

        if (this.qSearchField && this.qSearchField != '') {
          this.searchField = this.qSearchField
          this.documentary = true
          this.animation = true
          this.liveaction = true
          if (this.qTimeperiod == undefined) {
            this.timeperiod = []
          }
          if (this.qGenres == undefined) {
            this.genres = []
          }
          if (this.qQuality == undefined) {
            this.quality = []
          }
          if (this.qBuzz == undefined) {
            this.buzz = []
          } 
        }

        if (this.qSort == undefined || this.qSort != '') {
          this.prevSort = 'Quality'
        }

        if (this.prevSort == 'YearAsc') {
          this.dataIndex = 'movies_by_year_asc'
        } else if (this.prevSort == 'Year') {
          this.dataIndex = 'movies_by_year_desc'
        } else if (this.prevSort == 'BuzzAsc') {
          this.dataIndex = 'movies_by_buzz_asc'
        } else if (this.prevSort == 'Buzz') {
          this.dataIndex = 'movies_by_buzz_desc'
        } else if (this.prevSort == 'QualityAsc') {
          this.dataIndex = 'movies_by_quality_asc'
        } else {
          this.dataIndex = 'movies'
        }

        setTimeout(function() {
          vm.searchMatrix()
        }, 500)
      } else if ((this.qSearchField && this.qSearchField != '') && (this.qSearchValue && this.qSearchValue != '')) {
        this.prepMovieSearch(qSearchValue, qSearchField)
      }
    },
    beforeDestroy () {
      this.$eventHub.$off('do-movie-search')
    },
    methods: {
      resetDefaults: function () {
        this.genres = []
        this.timeperiod = []
        this.quality = []
        this.buzz = []
        this.documentary = true
        this.animation = true
        this.liveaction = true
        this.language = ['english', 'foreign']
      },
      prepMovieSearch: function (triggeredSearch, triggeredField) {
        // reset filters
        this.resetDefaults()
        this.searchTerm = ''
        this.searchField = ''

        // configure for selected term
        if (triggeredField == 'Genres') {
          if (triggeredSearch == 'War' || triggeredSearch == 'Western') {
            triggeredSearch = 'war-western'
          }
          if (triggeredSearch == 'Action' || triggeredSearch == 'Adventure') {
            triggeredSearch = 'action-adventure'
          }
          if (triggeredSearch == 'Thriller' || triggeredSearch == 'Mystery') {
            triggeredSearch = 'thriller-mystery'
          }
          if (triggeredSearch == 'Sci-Fi' || triggeredSearch == 'Fantasy') {
            triggeredSearch = 'sci-fi-fantasy'
          }
          this.genres = [triggeredSearch]
        } else {
          this.searchField = triggeredField
          this.searchTerm = triggeredSearch
        }
        
        if (this.qSort == undefined || this.qSort != '') {
          this.qSort = 'Quality'
        }

        this.prevSort = this.qSort
        if (this.prevSort == 'YearAsc') {
          this.dataIndex = 'movies_by_year_asc'
        } else if (this.prevSort == 'Year') {
          this.dataIndex = 'movies_by_year_desc'
        } else if (this.prevSort == 'BuzzAsc') {
          this.dataIndex = 'movies_by_buzz_asc'
        } else if (this.prevSort == 'Buzz') {
          this.dataIndex = 'movies_by_buzz_desc'
        } else if (this.prevSort == 'QualityAsc') {
          this.dataIndex = 'movies_by_quality_asc'
        } else {
          this.dataIndex = 'movies'
        }
        
        this.searchMatrix(true)
      },
      searchMatrix: function(reset) {
        let vm = this
        if (vm.isSearching) {
          return
        }
        vm.isSearching = true
        vm.noResultsFound = false
        if (reset) {
          vm.searchResults = []
          vm.nextPage = 0
        }
        vm.resultsType = 'matrixSearch'

        var filterString = ''

        // Genre
        if (vm.genres.length > 0) {
          filterString += '('
          for (var i = 0; i < vm.genres.length; i++) {
            var genre = vm.genres[i]
            if (genre == 'thriller-mystery') {
              filterString += 'Genres:Thriller OR Genres:Mystery'
            } else if (genre == 'war-western') {
              filterString += 'Genres:War OR Genres:Western'
            } else if (genre == 'sci-fi-fantasy') {
              filterString += 'Genres:Sci-Fi OR Genres:Fantasy'
            } else {
              filterString += 'Genres:' + genre
            }
            if (i+1 < vm.genres.length) {
              filterString += ' OR '
            }   
          }

          filterString += ')'
        }

        if (!vm.documentary) {
          if (filterString != '') {
            filterString += ' AND ' 
          }
          filterString += '(NOT Genres:Documentary)'
        }

        if (!vm.animation) {
          if (filterString != '') {
            filterString += ' AND ' 
          }
          filterString += '(NOT Genres:Animation)'
        }

        // Time period
        if (filterString != '') {
          filterString += ' AND '
        }
        if (vm.timeperiod.includes('pre-1960') && vm.timeperiod.includes('1960-1990') && vm.timeperiod.includes('since-1990') ) {
          filterString += ''
        } else if (vm.timeperiod.includes('1960-1990') && vm.timeperiod.includes('since-1990')) {
          filterString += 'Year > 1960'
        } else if (vm.timeperiod.includes('pre-1960') && vm.timeperiod.includes('since-1990')) {
          filterString += '(Year < 1960 OR Year > 1990)'
        } else if (vm.timeperiod.includes('pre-1960') && vm.timeperiod.includes('1960-1990')) {
          filterString += 'Year < 1990'
        } else if (vm.timeperiod.includes('since-1990')) {
          filterString += 'Year > 1990'
        } else if (vm.timeperiod.includes('pre-1960')) {
          filterString += 'Year < 1960'
        } else if (vm.timeperiod.includes('1960-1990')) {
          filterString += '(Year > 1960 AND Year < 1990)'
        }

        // Quality
        if (vm.quality.includes('quality-1') && vm.quality.includes('quality-2') && vm.quality.includes('quality-3') ) {
          filterString += ''
        } else if (vm.quality.includes('quality-1') && vm.quality.includes('quality-2')) {
          filterString += 'AND Quality <= 75 AND '
        } else if (vm.quality.includes('quality-1') && vm.quality.includes('quality-3')) {
          filterString += ' AND (Quality < 50 OR Quality > 74)'
        } else if (vm.quality.includes('quality-2') && vm.quality.includes('quality-3')) {
          filterString += ' AND Quality >= 50'
        } else if (vm.quality.includes('quality-1')) {
          filterString += ' AND Quality < 50'
        } else if (vm.quality.includes('quality-2')) {
          filterString += ' AND (Quality > 50 AND Quality < 74)'
        } else if (vm.quality.includes('quality-3')) {
          filterString += ' AND Quality > 75'
        }

        // Buzz
        if (vm.buzz.includes('buzz-1') && vm.buzz.includes('buzz-2') && vm.buzz.includes('buzz-3') ) {
          filterString += ''
        } else if (vm.buzz.includes('buzz-1') && vm.buzz.includes('buzz-2')) {
          filterString += ' AND Buzz <= 75'
        } else if (vm.buzz.includes('buzz-1') && vm.buzz.includes('buzz-3')) {
          filterString += ' AND (Buzz < 50 OR Buzz > 74)'
        } else if (vm.buzz.includes('buzz-2') && vm.buzz.includes('buzz-3')) {
          filterString += ' AND Buzz >= 50'
        }  else if (vm.buzz.includes('buzz-1')) {
          filterString += ' AND Buzz < 50'
        } else if (vm.buzz.includes('buzz-2')) {
          filterString += ' AND (Buzz > 50 AND Buzz < 74)'
        } else if (vm.buzz.includes('buzz-3')) {
          filterString += ' AND Buzz > 75'
        }

        if (vm.language.includes('english') && !vm.language.includes('foreign')) {
          filterString += ' AND Language:English'
        } else if (!vm.language.includes('english') && vm.language.includes('foreign')) {
          filterString += ' AND NOT Language:English'
        }

        if (vm.searchField && vm.searchField != '' && vm.searchTerm && vm.searchTerm != '') {
          if (filterString != '') {
            filterString += ' AND '
          }
          filterString += vm.searchField + ':"' + vm.searchTerm + '"'
        }

        console.log(filterString)
        if (filterString.substr(filterString.length - 4, 4) == 'AND ') {
          filterString = filterString.substring(0, filterString.length - 4)
        }
        console.log(filterString)
        
        // Set query
        vm.currentQuery = {}
        if (vm.buzz != '') {
          if (Array.isArray(vm.buzz)) {
           this.currentQuery.qBuzz = this.uniqueArray(vm.buzz)            
          }
          this.currentQuery.qBuzz = vm.buzz.join(",")
        }
        if (vm.quality != '') {
          if (Array.isArray(vm.quality)) {
           this.currentQuery.qQuality = this.uniqueArray(vm.quality)               
          }
          this.currentQuery.qQuality = vm.quality.join(",")
        }
        if (vm.timeperiod != '') {
          if (Array.isArray(vm.timeperiod)) {
           this.currentQuery.qTimeperiod = this.uniqueArray(vm.timeperiod)           
          }
          this.currentQuery.qTimeperiod = vm.timeperiod.join(",")
        }
        if (vm.genres != '') {
          if (Array.isArray(vm.genres)) {
           this.currentQuery.qGenres = this.uniqueArray(vm.genres)
          }
          this.currentQuery.qGenres = vm.genres.join(",")
        }
        if (vm.prevSort != '') {
          this.currentQuery.qSort = vm.prevSort
        } else {
          this.currentQuery.qSort = 'Quality'
        }
        if (vm.searchTerm != '') {
          this.currentQuery.qSearchValue = vm.searchTerm
        }
        if (vm.searchField != '') {
          this.currentQuery.qSearchField = vm.searchField
        }
        this.$router.push({query: this.currentQuery})

        // do search
        vm.resultsLoading = true
        vm.index.search({
          query: vm.searchTerm,
          filters: filterString,
          hitsPerPage: vm.searchLimit,
          page: vm.nextPage
        }).then(responses => {
          // Response from Algolia:
          // https://www.algolia.com/doc/api-reference/api-methods/search/#response-format
          var results = responses.hits
          vm.resultsCount = responses.nbHits
          if (vm.resultsCount == 0) {
            vm.noResultsFound = true
          }
          for (var i = 0; i < results.length; i++) {
            var obj = results[i]
            if (obj.PosterPath) {
              obj.Poster = 'https://image.tmdb.org/t/p/w185' + obj.PosterPath.replace(/ /g, "")
            }
            vm.searchResults.push(obj)
          }
          if (vm.nextPage == 0) {
            $('html, body').animate({ scrollTop: $('.search-matrix').offset().top + $('.search-matrix').outerHeight() + 26 }, 'slow')
          }
          vm.nextPage++
          vm.resultsLoading = false
          vm.isSearching = false
          setTimeout(function () {
            if (results.length > 0) {
              vm.enableLoadMore = true              
            }
          }, 4000)
          console.log('number of results: ' + results.length)
        })
      },
      uniqueArray: function(arrArg) {
        return arrArg.filter(function(elem, pos,arr) {
          return arr.indexOf(elem) == pos;
        });
      },
      loadMore: function () {
        if (this.searchResults.length > 0 && this.enableLoadMore && !this.isSearching) {
          console.log('loadMore')
          this.enableLoadMore = false
          this.searchMatrix()  
        }
      },
      sortChange: function (sortType) {
        this.enableLoadMore = false
        this.nextPage = 0
        this.setDataIndex(sortType)
        this.currentQuery.qSort = this.prevSort
        this.$router.push({query: this.currentQuery})
        this.searchResults = []
        this.searchMatrix()
      },
      setDataIndex: function(sortType) {
        if (sortType == 'Year' && this.prevSort == 'Year') {
          this.dataIndex = 'movies_by_year_asc'
          this.prevSort = 'YearAsc'
        } else if (sortType == 'Year') {
          this.dataIndex = 'movies_by_year_desc'
          this.prevSort = sortType
        } else if (sortType == 'Buzz' && this.prevSort == 'Buzz') {
          this.dataIndex = 'movies_by_buzz_asc'
          this.prevSort = 'BuzzAsc'
        } else if (sortType == 'Buzz') {
          this.dataIndex = 'movies_by_buzz_desc'
          this.prevSort = sortType
        } else if (sortType == 'Quality' && this.prevSort == 'Quality') {
          this.dataIndex = 'movies_by_quality_asc'
          this.prevSort = 'QualityAsc'
        } else {
          this.dataIndex = 'movies'
          this.prevSort = sortType
        }
        this.index = this.client.initIndex(this.dataIndex)
      }
    },
    mounted () {
      let vm = this
      var directorsIndex = vm.client.initIndex('directors')
      var actorsIndex = vm.client.initIndex('actors')

      $(document).on('click', 'h4.slide-toggle', function(e) {
        e.stopPropagation();
        $(this).next('div').stop().slideToggle(500);
      });

      autocomplete(
        '#search-term',
        {
          debug: true,
          templates: {
            dropdownMenu:
              '<div class="aa-dataset-actor"></div>' +
              '<div class="aa-dataset-director"></div>',
          },
        },
        [
          {
            source: autocomplete.sources.hits(actorsIndex, {hitsPerPage: 5}),
            displayKey: 'name',
            name: 'Cast',
            templates: {
              header: '<div class="aa-suggestions-category">Actors</div>',
              suggestion: function(suggestion) {
                return (
                  '<div><span>' +
                  suggestion._highlightResult.name.value +
                  '</span></div>'
                );
              },
              empty: '<div class="aa-empty">No matching actors</div>',
            },
          },
          {
            source: autocomplete.sources.hits(directorsIndex, {hitsPerPage: 7}),
            displayKey: 'name',
            name: 'Directors',
            templates: {
              header: '<div class="aa-suggestions-category">Directors</div>',
              suggestion: function(suggestion) {
                return (
                  '<div><span>' +
                  suggestion._highlightResult.name.value +
                  '</span></div>'
                );
              },
              empty: '<div class="aa-empty">No matching directors</div>',
            },
          },
        ]
      ).on('autocomplete:selected', function(event, suggestion, dataset) {
        vm.prepMovieSearch(suggestion.name, dataset)
      });
    },
    components: {
      MoviePanel
    }
  };
</script>

<style>
.algolia-autocomplete {
  width: 100%;
}
.aa-input-container {
  display: inline-block;
  position: relative;
}
.aa-empty {
  padding: 15px 12px;
  font-size: 12px;
}
.aa-input-search {
  padding: 18px 30px;
  font-size: 0.9em;
  box-sizing: border-box;
  border: 0;
  width: 335px;
  max-width: 100%;
  -webkit-transition: .2s;
  transition: .2s;
  box-sizing: border-box;
  color: #333;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.aa-input-search::-webkit-search-decoration, .aa-input-search::-webkit-search-cancel-button,
.aa-input-search::-webkit-search-results-button, .aa-input-search::-webkit-search-results-decoration {
  display: none;
}
.aa-input-search:focus {
  outline: 0;
}
.aa-input-icon {
  height: 16px;
  width: 16px;
  position: absolute;
  top: 50%;
  right: 16px;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
  fill: #e4e4e4;
  pointer-events: none;
}
.aa-hint {
  color: #ccc;
}
.aa-suggestion span:first-child em, .aa-suggestion span:last-child em {
    font-weight: 700;
    font-style: normal;
    background-color: rgba(58, 150, 207, 0.1);
    padding: 2px 0 2px 2px;
}
.aa-dropdown-menu {
  background-color: #fff;
  border: 2px solid rgba(228, 228, 228, 0.6);
  border-top-width: 0;
  width: 360px;
  margin-top: 10px;
  border-radius: 4px;
  box-sizing: border-box;
  margin-bottom: 30px;
}
.aa-suggestion {
  padding: 10px 12px;
  cursor: pointer;
  -webkit-transition: .2s;
  transition: .2s;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.aa-suggestion:hover, .aa-suggestion.aa-cursor {
  background-color: rgba(241, 241, 241, 0.5);
}
.aa-suggestion > span:first-child {
    color: #333;
    }
.aa-suggestion > span:last-child {
    text-transform: uppercase;
    color: #a9a9a9;
}
.aa-suggestions-category {
  text-transform: uppercase;
  font-size: 11px;
  border-bottom: 2px solid rgba(228, 228, 228, 0.6);
  border-top: 2px solid rgba(228, 228, 228, 0.6);
  padding: 10px 12px;
  color: #a9a9a9;
}
.aa-suggestion > span:first-child em, .aa-suggestion > span:last-child em {
  font-weight: 700;
  font-style: normal;
  background-color: rgba(58, 150, 207, 0.1);
  padding: 2px 0 2px 2px;
}

</style>
<style scoped>
  .results-loader {
    width: 100%;
    text-align: center;
    padding: 20px 0;
    font-size: 2em;
  }
  .section-panel {
    background: #fff;
    padding: 25px 15px;
    margin: 0 5px 5px;
  }
  .hiddenCB h4 {
    margin-top: 0;
    margin-bottom: 5px;
    font-size: 0.9em;
    line-height: 28px;
  }
  .hiddenCB h4.slide-toggle {
    cursor: pointer;
  }
  .hiddenCB h4 i {
    float: right;
    margin-top: 9px;
  }
  .hiddenCB p {
    font-size: 0.9em;
  }
  .hiddenCB p span.underline {
    text-decoration: underline;
  }
  .hiddenCB p span.italic {
    font-style: italic;
  }
  .search-form .search-matrix {
    width: 100%;
    margin: 10px 0 0;
    padding: 20px;
    background: rgb(41,100,134);
    background: -moz-linear-gradient(90deg, rgba(41,100,134,1) 0%, rgba(49,129,174,1) 100%);
    background: -webkit-linear-gradient(90deg, rgba(41,100,134,1) 0%, rgba(49,129,174,1) 100%);
    background: linear-gradient(90deg, rgba(41,100,134,1) 0%, rgba(49,129,174,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#296486",endColorstr="#3181ae",GradientType=1);
    color: #fff;
    font-weight: bold;
    text-transform: uppercase;
  }
  .hiddenCB div {
    display: block;
    margin: 0 0 10px;
    padding: 0;
    list-style: none;
  }
  
  .hiddenCB div.slide-hidden {
    display: none;
  }

  .hiddenCB input[type="checkbox"],
  .hiddenCB input[type="radio"] {
    display: none;
    
  }

  .hiddenCB label, .hiddenCB .sort-button {
    cursor: pointer;
    padding: 0px 12px;
    margin: 0 1% 10px 0;
    display: inline-block;
    background: #fff;
    border: 1px solid #eff3f7;
    font-size: 0.9em;
    white-space: nowrap;
    text-align: center;
    box-sizing: border-box;
    line-height: 50px;
    vertical-align: top;
  }
  .hiddenCB label.has-subtext, .hiddenCB .sort-button.has-subtext {
    line-height: 15px;
    padding: 10px 15px;
  }
  .hiddenCB .sort-button i {
    margin-left: 5px;
  }

  .hiddenCB label span, .hiddenCB .sort-button.has-subtext span {
    display: block;
    font-size: 0.7em;
    color: #ccc;
  }

  .hiddenCB label:last-child {
    margin-right: 0;
  }

  #time-period label, #quality label, #buzz label, #include label, #sortby button {
    width: 31%;
  }
  #language label {
    width: 48.7%;
  }

  /*.hiddenCB input[type="checkbox"]+label:hover,
  .hiddenCB input[type="radio"]+label:hover {
    background: #4a97e0;
    color: #fff;
  }*/

  .hiddenCB input[type="checkbox"]:checked+label,
  .hiddenCB input[type="radio"]:checked+label,
  .hiddenCB .sort-button.selected-button {
    background: #3181AD;
    color: #fff;
  }

  .hiddenCB h4.search-heading {
    margin-top: 20px;
  }

  .hiddenCB div.search-term {
    box-shadow: 0px 0px 10px -3px rgba(0,0,0,0.5);
    margin: 0 0 20px;
  }

  #search-term {
    width: 100%;
    padding: 18px 30px;
    font-size: 0.9em;
    box-sizing: border-box;
    border: 0;
  }

  .results-panel p span {
    text-decoration: underline;
  }

  .list-panel ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/SearchForm.vue